import React from 'react';
import './styles.scss';
import TeamMember from '../TeamMember';
import RishiImage from 'assets/about-us/team/Rishi.png';
import SimonImage from 'assets/about-us/team/Simon.png';
import KellyImage from 'assets/about-us/team/kelly.png';
import HudaImage from 'assets/about-us/team/huda.png';
import JimImage from 'assets/about-us/team/frenette.png';
import AmitImage from 'assets/about-us/team/amit.png';
import SallyImage from 'assets/about-us/team/sally.png';
import TimImage from 'assets/about-us/team/Tim.png';
import TeddyImage from 'assets/about-us/team/teddy.png';

const AboutUsUrbianTeamSection = () => {
  return (
    <div className="__AboutUsUrbianTeamSection font_lato">
      <div className="__my-container-v2">
        <h4 className="font_montserrat font-weight-mediam-bold __title __m-0 __primary-text-color __main-title">The Urbain Team</h4>
        <TeamMember
          name="Rishi Nigam"
          avatar={RishiImage}
          jobTitle="CHIEF EXECUTIVE OFFICER"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/rishinigam15/"
          email="rishi@urbainco.com"
        >
          Rishi started his Urbain journey many years ago while leading corporate and strategic development for the Wyndham Destination Network. Over
          a decade and a half working with WDN’s short-term rental businesses, Rishi developed a real passion for living like a local. Armed with
          wanderlust and a passport, Rishi has been fortunate to work and play in many corners of the earth. After leaving WDN, Rishi couldn’t shake
          the idea that urban STRs needed to be better, which drove him to begin assembling the team and the plan for Urbain. This venture combines
          Rishi’s passion to explore culture, community and cuisine in one glorious mission. Rishi is an avid skier, cook and is currently basking in
          the glory of a Dodgers World Series. He is married to another avid traveler and foodie, and father to a whippersnapper of a toddler who
          loves nothing more than music, dance, skiing fast and cacio e pepe. Generally not at the same time…that would be messy.
        </TeamMember>
        <TeamMember
          name="Simon Law"
          avatar={SimonImage}
          jobTitle="CHIEF PORTFOLIO OFFICER"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/simon-law-1a0a893/"
          email="simon@urbainco.com"
        >
          Since the very week he left university, Simon has worked in Vacation Rentals. With a real passion for travel and an entrepreneurial streak,
          he’s never once looked back! He has an intimate knowledge of France, Italy, Iberia, and the US, having built vacation businesses up from
          scratch in those countries. A career that included time spent at Wyndham, allowed Simon to make strong relationships with the Urbain team
          members who also worked there. Serendipity and a lot of planning has lead to this latest exciting chapter - Urbain. Homelife revolves around
          a husband and two lively working cocker spaniels. No time is better spent that when all together in front of the fire in their 300-year-old
          English home. Otherwise, downtime means cooking something new, hiking or off-road motorcycling and spending time in rural Gascony.
        </TeamMember>
        <TeamMember
          name="Kelly McGuire"
          avatar={KellyImage}
          jobTitle="CHIEF COMMERICAL OFFICER"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/mcguirekelly/"
          email="kelly@urbainco.com"
        >
          Before starting on this Urbain adventure, Kelly was Senior Vice President of Revenue Management at MGM Resorts, and held a position as Vice
          President of Analytics at Wyndham Destinations.  Kelly&#39;s two favorite things are pricing and travel, so when Rishi called, joining was a
          no-brainer!  What a perfect opportunity to work globally with a world class team, solving commercial problems that haven&#39;t yet been
          cracked!  An active author and public speaker, she&#39;s been known to use 80s movies, 90s hip hop and Star Wars analogies to explain data
          science to business leaders.   In her spare time, Kelly can be found on the golf course, or in the kitchen trying new recipes, that is, when
          she&#39;s not exploring fabulous destinations around the world, or in her own backyard!
        </TeamMember>
        <TeamMember
          name="Jim Frenette"
          avatar={JimImage}
          jobTitle="HEAD OF TECHNOLOGY"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/jimfrenette/"
          email="jim@urbainco.com"
        >
          Jim came to Urbain with 20 years of leading technology strategy and implementation for a gamut of start-ups. From building one of the first
          premium online learning platforms for eCornell to co-founding Synapse Games and building mobile games for millions of players, he’s always
          excited for a new challenge. Jim fell into hospitality by opening Pixel Lounge, an arcade, craft beer bar, and entrepreneurial gathering
          spot for the Cornell community. There were many lessons learned that probably could have been skipped had he met his wife, a hospitality
          consultant, first. They, with their two children, enjoy frequent trips to the coast where the subject of conversation inevitably gets to why
          their home stay has 4 pasta ladles and no pots. Jim is excited to be part of fixing this.
        </TeamMember>
        <TeamMember
          name="Amit Nigam"
          avatar={AmitImage}
          jobTitle="HEAD OF PRODUCT"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/amit-nigam-b2ba4022/"
          email="amit@urbainco.com"
        >
          Amit joined the Urbain team after spending the first 14 years of his career working in advertising. In his time in the advertising space,
          Amit worked with some of the biggest brands in the country, helping them devise their communication strategies and activation. Additionally,
          in his role as Head of Product, he was tasked with developing a roadmap that would bring continual technological innovation to the business.
          In that time, he realized that he had passion for startups and technology, and it made bringing his experience to the Urbain team an easy
          choice. In his free time, he loves traveling with his family and friends, often using STRs, and found a serious connection to the goals of
          Urbain. Amit is also a passionate Buffalo Bills fan, as well as a huge fan of cooking and BBQ. He lives in New Jersey with his wife and
          three children.
        </TeamMember>
        <TeamMember
          name="Sally Henry"
          avatar={SallyImage}
          jobTitle="HEAD OF STRATEGIC PARTNERSHIPS & DISTRIBUTION"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/sally-henry-3516229/"
          email="sally@urbainco.com"
        >
          Sally is passionate about all aspects of vacation rentals and during her 19 year career at Wyndham / Awaze UK as Sales Director she was
          instrumental in forging partnerships with all of the major OTAs and grew a network with hundreds of industry partners . She enjoyed working
          with Rishi and the team at a group level and jumped at the chance to work with them again to help establish and grow Urbain as a global
          brand. Sally lives in Yorkshire with her partner, two children and cockapoo and when not working can be found running through the
          countryside with her dog, socialising with friends or watching sport (particularly rugby).
        </TeamMember>
        <TeamMember
          name="Tim Koropsak"
          avatar={TimImage}
          jobTitle="HEAD OF FINANCE"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/timothy-koropsak-cfa-a72a2231/"
          email="tim@urbainco.com"
        >
          Tim made the decision to join Urbain upon receiving a phone call from ex-colleague Rishi.  Once Rishi explained what he was putting
          together, Tim immediately knew it was something he wanted to be a part of.  A 19-year veteran working in finance within hospitality, he has
          been part of the financial planning and strategic development for a variety of travel products, including hotels, timeshares and vacation
          rentals.  The opportunity to reconnect with people whom he trusts, believes in and enjoys working, along with building something special,
          was a once in a lifetime opportunity.  Tim lives on the top of a mountain with his understanding wife Erin, their high-spirited daughter
          Brynn and senior-Pug Moe.  While not spending time with his real family, Urbain family or tending to his lawn, Tim can be seen reliving the
          glory days of the NY football Giants.
        </TeamMember>

        <TeamMember
          name="Teddy Anastasiou"
          avatar={TeddyImage}
          jobTitle="HEAD OF PUBLIC POLICY"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/tedanastasiou/"
          email="ted@urbainco.com"
        >
          Teddy jumped on the opportunity to join Urbain after recognizing the outsized potential the Company has on making a real positive impact for
          travelers and the communities they visit. With over a decade of experience advising companies and governments, and a successful turn as a
          start-up founder, Ted knew that Urbain would be the ultimate testing ground for leveraging his diverse professional background into a
          singular purpose that he’s passionate about: helping people travel better. When he’s not working, Teddy spends his time reading science
          fiction and biographies, wearing brightly-colored athleisure wear while exercising, and sipping a latte while strolling the varied
          neighborhoods of New York City.
        </TeamMember>
        <TeamMember
          name="Imrul Huda"
          avatar={HudaImage}
          jobTitle="HEAD OF STRATEGY"
          twitterURL="http://www.twitter.com/"
          linkedinURL="https://www.linkedin.com/in/imrul-huda-557790169/"
          email="Imrul@urbainco.com"
        >
          Imrul spent more than a decade in the hospitality space, executing strategy and growth initiatives the vacation rental business for Wyndham
          Destination Network. While the opportunities and experience were rewarding, Imrul had always felt the yearning to do something uniquely
          exciting within the lodging space, preferably with a group of like-minded people. So, when Rishi shared his vision for Urbain, Imrul decided
          it was now or never. Imrul lives with his wife in Pennsylvania, and when they are not traveling and taking in the sights, they can often be
          found curled up on the couch watching classic films.
        </TeamMember>
      </div>
    </div>
  );
};

export default AboutUsUrbianTeamSection;
